let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kM5GB")).then(() => parcelRequire('kzcZp'));